import { useState } from "react";
import SystemModal from "../Common/SystemModal";
import ajaxRequisitions from "../../util/remote/ajaxRequisitions";
import toast, { Toaster } from "react-hot-toast";

const RejectedItemsRequisitionDetailsModal = ({ data, org, func }) => {
  const orgInfo = {
    name: "LA_PROCURE AFRICA LIMITED",
    lines: [
      "P.O.BOX 28775 KAMPALA",
      "PLOT 79B BOMBO ROAD",
      "TEL: +256701666160",
      "EMAIL: info@laprocure.africa",
    ],
    logoSrc: `${process.env.PUBLIC_URL}/assets/img/brand/icon-light.png`,
    watermarkSrc: `${process.env.PUBLIC_URL}/assets/img/brand/icon-light.png`,
    ...org,
  };

  // Track which rejected items are now allowed
  const [rejectedItems, setRejectedItems] = useState(
    data.rejected_items.map((item) => ({ ...item, allow: false }))
  );

  const [loading, setLoading] = useState(false);

  // Toggle allow status
  const toggleAllow = (id) => {
    setRejectedItems((prev) =>
      prev.map((it) => (it.id === id ? { ...it, allow: !it.allow } : it))
    );
  };

  // Save changes
  const handleSave = async () => {
    const itemsToApprove = rejectedItems
      .filter((it) => it.allow)
      .map((it) => it.id); // send only IDs

    if (itemsToApprove.length === 0)
      return alert("No items selected to allow.");

    setLoading(true);

    // send only the IDs along with requisition ID
    const server_response = await ajaxRequisitions.allowRejectedItems({
      requisition_id: data.id,
      item_ids: itemsToApprove,
    });

    setLoading(false);

    if (server_response.status === "OK") {
      toast.success(server_response.message);
      func(); // refresh parent
    } else {
      toast.error(server_response.message);
    }
  };

  const Print = (e, controls) => {
    e.preventDefault();
    const html = document.getElementById("printablediv").innerHTML;
    const w = window.open("", "parent");
    w.document.open();
    w.document.write(`
      <html>
        <head>
          <title>Material Requisition</title>
          <style>${baseStyles(orgInfo.watermarkSrc)}</style>
        </head>
        <body>${html}</body>
      </html>
    `);
    w.document.close();
    w.focus();
    w.print();
    w.onafterprint = () => w.close();
    w.onfocus = () =>
      setTimeout(() => {
        if (!w.closed) w.close();
      }, 500);
  };

  const RenderFooter = (controls) => (
    <>
      <button
        className="btn ripple btn-dark"
        type="button"
        onClick={controls.close}
      >
        Close
      </button>
      <button
        className="btn ripple btn-success"
        type="button"
        onClick={handleSave}
        disabled={loading}
      >
        {loading ? "Processing..." : "Allow Selected Items"}
      </button>
      <button
        className="btn ripple btn-dark"
        type="button"
        onClick={(e) => Print(e, controls)}
      >
        Print
      </button>
    </>
  );

  return (
    <SystemModal
      title="Requisition Details"
      id="model-requisition"
      size="xl"
      footer={RenderFooter}
    >
      <style>{baseStyles(orgInfo.watermarkSrc)}</style>
      <div id="printablediv">
        <div className="doc">
          <div className="doc-content">
            {/* Header & Meta info */}
            <Toaster />
            <div className="doc-header">
              <div className="logo-wrap">
                <img src={orgInfo.logoSrc} alt="Logo" />
              </div>
              <div className="org-text">
                <div className="org-name">{orgInfo.name}</div>
                {orgInfo.lines.map((l, i) => (
                  <div key={i} className="org-line">
                    {l}
                  </div>
                ))}
              </div>
            </div>
            <div className="title">MATERIAL REQUISITION FORM</div>
            <table className="meta">
              <tbody>
                <tr>
                  <td>
                    <b>Date:</b> {data.date_created}
                  </td>
                  <td>
                    <b>Requisition ID:</b> {data.id}
                  </td>
                  <td>
                    <b>Status:</b>{" "}
                    {data.status === "1" ? "Approved" : "Pending"}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Department:</b> {data.department}
                  </td>
                  <td>
                    <b>Prepared By:</b> {data.first_name} {data.last_name}
                  </td>
                  <td>
                    <b>Estimated Total:</b> {data.est_total}
                  </td>
                </tr>
                <tr>
                  <td colSpan="3">
                    <b>Narration:</b> {data.naration}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Approved Items */}
            <h5>Approved Items</h5>
            <table className="items">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item Description</th>
                  <th>Unit</th>
                  <th>Qty</th>
                  <th>Est. Unit Cost</th>
                  <th>Actual Cost</th>
                  <th>SubTotal</th>
                </tr>
              </thead>
              <tbody>
                {data.allowed_items.length ? (
                  data.allowed_items.map((it, idx) => (
                    <tr key={it.id}>
                      <td>{idx + 1}</td>
                      <td>{it.item_name}</td>
                      <td>{it.unit}</td>
                      <td>{it.quantity}</td>
                      <td>{it.est_unit_cost}</td>
                      <td>{it.actual_cost ?? "-"}</td>
                      <td>{it.sub_total ?? "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      No approved items
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Rejected Items */}
            <h5 style={{ marginTop: "20px" }}>Rejected Items</h5>
            <table className="items">
              <thead>
                <tr>
                  <th>Allow?</th>
                  <th>#</th>
                  <th>Item Description</th>
                  <th>Unit</th>
                  <th>Qty</th>
                  <th>Est. Unit Cost</th>
                  <th>Actual Cost</th>
                  <th>SubTotal</th>
                </tr>
              </thead>
              <tbody>
                {rejectedItems.length ? (
                  rejectedItems.map((it, idx) => (
                    <tr key={it.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={it.allow}
                          onChange={() => toggleAllow(it.id)}
                        />
                      </td>
                      <td>{idx + 1}</td>
                      <td>{it.item_name}</td>
                      <td>{it.unit}</td>
                      <td>{it.quantity}</td>
                      <td>{it.est_unit_cost}</td>
                      <td>{it.actual_cost ?? "-"}</td>
                      <td>{it.sub_total ?? "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center" }}>
                      No rejected items
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};

const baseStyles = (watermarkSrc) => `
  * { box-sizing: border-box; }
  body { font-family: Arial, sans-serif; }
  .doc {
    position: relative;
    padding: 18mm 15mm;
    min-width: 210mm;
    max-width: 210mm; 
    margin: 0 auto;
    background: #fff;
    border: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  .doc::before {
    content: "";
    position: absolute;
    inset: 0;
    background: url("${watermarkSrc}") no-repeat center center;
    background-size: 60%;
    opacity: 0.2;
    z-index: 0;
  }
  .doc-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
  }
  .doc-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 8px;
    position: relative;
    z-index: 2;
  }
  .logo-wrap img { width: 180px; height: 180px; object-fit: contain; }
  .org-text { flex: 1; text-align: center; }
  .org-name { font-size: 20px; font-weight: 700; letter-spacing: .5px; }
  .org-line { font-size: 12px; line-height: 1.2; }
  .title {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    margin: 6px 0 10px 0;
    position: relative; z-index: 2;
  }
  table { border-collapse: collapse; width: 100%; margin-top: 10px; position: relative; z-index: 2; }
  th, td { border: 1px solid #111; padding: 6px 8px; font-size: 12.5px; vertical-align: top; }
  th { background: #f2f2f2; text-align: left; }
  .meta { margin-bottom: 12px; }
  .meta td { border: 1px solid transparent; padding: 4px 0; font-size: 13px; }
  .meta tr td:first-child, .meta tr td:nth-child(2), .meta tr td:nth-child(3) { border: none; }
  .items th:nth-child(4) { width: 40%; }
  .totals { margin-top: 16px; width: 200px; }
  .totals td:first-child { width: 60%; }
  .signature { margin-top: auto; }
  .signature .line { margin-top: 16px; border-bottom: 1px solid #111; width: 60%; height: 20px; }
  .footer-print { margin-top: 18px; font-size: 11px; text-align: right; color: #374151; position: relative; z-index: 2; }
  @page { size: A4; margin: 12mm; }
`;

export default RejectedItemsRequisitionDetailsModal;
